import { Button, Card, CardColors, Heading, HeadingVariants, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { useFeatureAnnouncement } from './useFeatureAnnouncement'
import { InlineLinkText } from './renderInlineLinks'

const DEFAULT_DISMISS_LABEL = "Don't show again"

export const FeatureAnnouncementCard = () => {
  const result = useFeatureAnnouncement()
  if (!result) return null

  const { announcement: a, imageSrc, onCtaClick, onDismiss } = result
  return (
    <Card
      color={CardColors.EMPHASIS}
      childrenClassName="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-16"
    >
      <div className="flex flex-1 flex-col gap-4">
        <header className="flex flex-col gap-1">
          {a.eyebrow && (
            <Text variant={TypographyStyles.EYEBROW} color={TextColors.MUTED}>
              {a.eyebrow}
            </Text>
          )}
          <Heading variant={HeadingVariants.H1} className="text-neutral-900">
            <InlineLinkText text={a.title} />
          </Heading>
          {a.subhead && (
            <Text variant={TypographyStyles.BODY_SM} className="block">
              {a.subhead}
            </Text>
          )}
        </header>

        <Text variant={TypographyStyles.BODY_MD} color={TextColors.DEFAULT}>
          <InlineLinkText text={a.body} />
        </Text>

        <div className="flex gap-2">
          <Button onClick={onCtaClick}>{a.ctaLabel}</Button>
          <Button variant="secondary" onClick={onDismiss}>
            {a.dismissLabel ?? DEFAULT_DISMISS_LABEL}
          </Button>
        </div>

        {a.disclaimer && (
          <Text
            variant={TypographyStyles.BODY_XS}
            color={TextColors.MUTED}
            className="block"
          >
            <InlineLinkText text={a.disclaimer} />
          </Text>
        )}
      </div>

      <img
        src={imageSrc}
        alt={a.title}
        className="hidden h-[180px] w-[180px] shrink-0 sm:block"
      />
    </Card>
  )
}
